export default __webpack_public_path__ + "static/just-4f499bd8f34e9bda59b08e668e6c0bb3.png";